module.exports = __webpack_public_path__ + "img/logo-white-bg.0b96a756.svg";